import React, { useEffect, useState } from 'react'
import { Modal, Select, Form, Input } from 'antd'
import { queryDicts } from '@/services/basicinfo'
import CustomerPicker from '@/components/CustomerPicker'
const { Option } = Select
const { TextArea } = Input
import { CLINIC_KEY } from '@/utils/consts'
const formItemLayout = { labelCol: { span: 6 }, wrapperCol: { span: 14 } }
const FollowModal = ({ data = {}, form, onOk, typsId, ...modalProps }) => {
  const { getFieldDecorator } = form
  const clinicId = localStorage.getItem(CLINIC_KEY)

  const [workTypes, setWorkTypes] = useState([])
  const [typs, setTyps] = useState(undefined)
  const [showOther, setShowOther] = useState(false)

  useEffect(() => {
    queryDicts({ type: 'WORK_TYPE' }).then((res) => {
      const { code, data: { rows } } = res
      if (code === 0) {
        if (typsId) {
          let typs = rows.filter(_ => _.key === '取消预约')[0].id
          setTyps(typs)
        }
        setWorkTypes(rows)
      }
    })
    if (data.id && !data.type) {
      form.setFieldsValue({ type: 0, other: data.typeName })
      setShowOther(true)
    }
  }, [data.customerName])

  const handleOk = () => {
    const { validateFields, getFieldsValue } = form

    validateFields(errors => {
      if (errors) {
        return
      }
      const params = getFieldsValue()
      delete params.customerName
      const { other, type } = params
      if (type === 0) {
        params.type = null
        delete params.other
        params.typeName = other
      } else {
        params.typeName = workTypes.filter(_ => _.id === params.type)[0].key
      }

      onOk({
        id: data.id || undefined,
        followUpId: data.followUpId || (data.id || data.followUpType === 'Reservation' ? undefined : data.customerId),
        followUpType: data.id ? undefined : (data.followUpType || 'Customer'),
        ...params
      }, data.customerId)
    })
  }

  return (
    <Modal {...modalProps} onOk={() => handleOk()}>
      <Form layout="horizontal">
        {
          data.customerName ?
            <Form.Item label="客户" {...formItemLayout}>
              {getFieldDecorator('customerName', {
                initialValue: data.customerName,
              })(
                <Input autoComplete="off" disabled />
              )}
            </Form.Item>
            :
            <Form.Item label="客户姓名" {...formItemLayout}>
              {getFieldDecorator('followUpId', {
                rules: [{ required: true, message: '必选项' }]
              })(
                <CustomerPicker clinicId={clinicId} />
              )}
            </Form.Item>
        }
        <Form.Item label="工作类别" {...formItemLayout}>
          {getFieldDecorator('type', {
            initialValue: data.type || typs,
            rules: [
              {
                required: true,
                message: '请选择工作类别'
              },
            ],
          })(
            <Select getPopupContainer={triggerNode => triggerNode.parentNode} onChange={(val) => setShowOther(val === 0)} disabled={typs}>
              {workTypes.map(_ => <Option key={_.id} value={_.id}>{_.key}</Option>)}
              <Option value={0}>其他</Option>
            </Select>
          )}
        </Form.Item>
        {showOther && <Form.Item label="其他工作" {...formItemLayout}>
          {getFieldDecorator('other', {
            initialValue: (!data.type && data.typeName) ? data.typeName : undefined,
            rules: [
              {
                required: true,
                message: '请填写其他工作'
              },
            ],
          })(
            <Input />
          )}
        </Form.Item>}
        <Form.Item label="随访情况" {...formItemLayout}>
          {getFieldDecorator('content', {
            initialValue: data.content,
            rules: [
              {
                required: true,
                message: '请填写随访情况'
              },
            ],
          })(
            <TextArea autoComplete="off" autoSize={{ maxRows: 8, minRows: 3 }} />
          )}
        </Form.Item>
        <Form.Item label="备注" {...formItemLayout}>
          {getFieldDecorator('comment', {
            initialValue: data.comment,
          })(
            <TextArea autoComplete="off" autoSize={{ maxRows: 8, minRows: 3 }} />
          )}
        </Form.Item>
      </Form>
    </Modal>
  )
}
export default Form.create()(FollowModal)